import React from 'react';
import PopupFrame from '../../layout/parts/PopupFrame'
import HidingElement from '../utils/HidingElement'

import PublicOffer from '../messages/PublicOffer'
import Rules from '../messages/Rules'
import SuccessfulBooking from '../messages/SuccessfulBooking'
import Pixel, {PIXEL_ACTIONS} from '../utils/Pixel'
import Loader from '../utils/Loader'

export class PublicOfferPopup extends HidingElement {
    renderIfEnabled() { 
        return (
            <PopupFrame
                    title="Публичная оферта"
                    onClose={this.props.onClose} >
                <div className="tickets-reading-block">
                    <PublicOffer />
                </div>
                <Pixel action={PIXEL_ACTIONS.WIDGET_VIEW_PUBLIC_OFFER} />
            </PopupFrame>
         );
    }
}

export class RulesPopup extends HidingElement {
    renderIfEnabled() { 
        return (
            <PopupFrame
                    title="Правила оплаты"
                    onClose={this.props.onClose} >
                <div className="tickets-reading-block">
                    <Rules />
                </div>
                <Pixel action={PIXEL_ACTIONS.WIDGET_VIEW_RULES} />
            </PopupFrame>
         );
    }
}

export class SuccessfulBookingPopup extends HidingElement {
    renderIfEnabled() { 
        return (
            <PopupFrame
                    title="Завершение покупки"
                    onClose={this.props.onClose} >
                <div className="tickets-reading-block">
                    <SuccessfulBooking />
                </div>
                <center>
                    <Loader message="Регистрация покупки..."/>
                </center>
            </PopupFrame>
         );
    }
}

export class RedirectionToBankPopup extends HidingElement {
    renderIfEnabled() { 
        return (
            <PopupFrame
                    title="Завершение покупки"
                    onClose={this.props.onClose} >
                <div className="tickets-reading-block">
                    <h4>
                        Перенаправление в банк
                    </h4>
                    <div>
                        <center>
                            <Loader message="Перенаправление на платежную страницу..." />
                        </center>
                        <br />
                        Если длительное время ничего не происходит, 
                        пожалуйста, перейтите самостоятельно по &nbsp;
                        <a 
                            title='Платежная страница банка'
                            href={this.props.paymentLink}>этой ссылке</a>.
                    </div>
                </div>
            </PopupFrame>
         );
    }
}

export class BookingInProgressPopup extends HidingElement {
    renderIfEnabled() { 
        console.log('payment link:', this.props)
        return (
            <PopupFrame
                    title="Завершение покупки"
                    onClose={this.props.onClose} >
                <div className="tickets-reading-block">
                    <h4>
                        Бронирование билетов
                    </h4>
                    <div>
                        <center>
                            <Loader message="Отправка запроса на бронирование..." />
                        </center>
                    </div>
                </div>
            </PopupFrame>
         );
    }
}